export const HeadTitle = ({text}) => {
    return (
        <div className="head-title mt-3">
            {text}
            <div className="head-line" />
        </div>
    )
}